















import { SdsAlert } from '@superbet-group/web.lib.ui-components';
import {
    defineComponent,
    onBeforeUnmount,
    watch,
} from '@vue/composition-api';

const ANIMATION_DURATION = 4000; // ms

export default defineComponent({
    name: 'Error',
    emits: ['fadeOut'],
    props: {
        error: {
            type: String,
            required: true,
        },
        shouldFadeOut: {
            type: Boolean,
            required: false,
            default: false,
        },
        isWarning: {
            type: Boolean,
            required: true,
        },
        isClosable: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    setup(props, { emit }) {
        let timeout: ReturnType<typeof setTimeout> | null = null;
        if (props.shouldFadeOut) {
            fadeOut();
        }
        watch(() => props.error, (newError) => {
            if (props.shouldFadeOut && newError) {
                fadeOut();
            }
        });
        function afterLeave() {
            emit('fadeOut');
        }
        function fadeOut() {
            if (timeout != null) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                emit('fadeOut');
            }, ANIMATION_DURATION);
        }
        onBeforeUnmount(() => {
            if (timeout != null) {
                clearTimeout(timeout);
            }
        });
        return {
            afterLeave,
        };
    },
    components: { SdsAlert },
});
